<mat-card appearance="outlined" class="no-recording-card">
    <mat-card-content>
        <p i18n="@@home.noRecording.message.noData">記録がありません。GOKURIで計測をしてください。</p>
    </mat-card-content>
</mat-card>
